import HollywoodHeroSection from "./components/HeroSection";
import HollywoodStickyNav from "./components/StickyNav";
import HollywoodProcessingTimeSection from "./components/ProcessingTimeSection";
import HollywoodServicesSection from "./components/ServicesSection";
import HollywoodLocalAreaSection from "./components/LocalAreaSection";
import HollywoodTravelTimingSection from "./components/TravelTimingSection";
import HollywoodDestinationsSection from "./components/DestinationsSection";
import HollywoodTestimonialsSection from "./components/TestimonialsSection";
import HollywoodAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import HollywoodComparisonSection from "./components/ComparisonSection";
import HollywoodMistakesSection from "./components/MistakesSection";
import HollywoodHowItWorksSection from "./components/HowItWorksSection";
import HollywoodFAQSection, { faqs } from "./components/FAQSection";
import HollywoodHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import HollywoodFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Hollywood, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Hollywood, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Broward County travelers.";

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function HollywoodPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Hollywood"
        state="Florida"
        stateAbbr="FL"
        route="/cities/hollywood"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Hollywood, Florida"
        geoPosition="26.0112;-80.1495"
        keywords="expedited passport Hollywood, emergency passport Hollywood FL, same day passport Hollywood, fast passport Broward County, passport renewal Hollywood, Hollywood passport courier"
        faqs={faqs.map((f: { q: string; a: string }) => ({ q: f.q, a: f.a }))}
        servicesSchema={servicesSchema}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-14"
      />
      <HollywoodHeroSection />
      <HollywoodStickyNav />
      <HollywoodProcessingTimeSection />
      <HollywoodServicesSection />
      <HollywoodLocalAreaSection />
      <HollywoodTravelTimingSection />
      <HollywoodDestinationsSection />
      <HollywoodTestimonialsSection />
      <HollywoodAcceptanceFacilitiesSection />
      <HollywoodComparisonSection />
      <HollywoodMistakesSection />
      <HollywoodHowItWorksSection />
      <HollywoodFAQSection />
      <HollywoodHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/hollywood" state="FL" />
      <HollywoodFinalCTA />
    </div>
  );
}